import api from "../../../api/axios";

export function fetchClientPresentations(clientId, { signal } = {}) {
  return api
    .get(`/crm/clients/${clientId}/presentations/`, { signal })
    .then((res) => res.data);
}

export function unwrapPresentationList(data) {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.results)) return data.results;
  return [];
}
